// !when there are 4-projects

const projects = {
  imageContentHeight: 630,
  contactTitleMinLimit: 835,
  skillsTitleMinLimit: 745
};
export default projects;

// !when there are 6-projects

// const projects = {
//   imageContentHeight: 900,
//   contactTitleMinLimit: 1040,
//   skillsTitleMinLimit: 950
// };
// export default projects;

//  !Also required to change the bottom property in every image component
